import { useAuthStore } from "@/store/auth";
import OrgDashboardPage from "./OrgDashboardPage";
import StaffDashboardPage from "./StaffDashboardPage";
import UnitDashboardPage from "./UnitDashboardPage";

export default function RoleBasedDashboard() {
  const user = useAuthStore((s) => s.user);
  if (!user) return null;
  if (user.is_staff) return <StaffDashboardPage />;
  if (user.role?.name === "UNIT_VIEWER") return <UnitDashboardPage />;
  return <OrgDashboardPage />;
}
